/** Railway account pages explicitly disallow foreign frames (CSP frame-ancestors
 * self https://railway.com and X-Frame-Options SAMEORIGIN, verified 2026-11-04).
 * Only the browser iframe path uses this; Electron keeps its normal account view. */
export function kontoNurImEigenenTab(url: string): boolean {
  try {
    const u = new URL(url);
    return u.protocol === 'https:' && u.hostname === 'railway.com'
      && (u.pathname === '/account' || u.pathname.startsWith('/account/'));
  } catch { return false; }
}
